import { createApi } from '@reduxjs/toolkit/query/react';
import { ENDPOINT_URL, GET_LINK_AGG_API_FOR_PORT_PREVIEW, GET_LINK_KAGGREGATIONS, GET_MIRROR_LIST } from '../../constants/commonConstants';
import { decryptData } from '../../utils/crypto';
import { axiosBaseQuery } from '../../utils/axiosBaseQuery';

// Define the base API slice
export const switchQueryApiSlice = createApi({
    reducerPath: 'switch_query_api',
     baseQuery: axiosBaseQuery({
        baseUrl: ENDPOINT_URL,
    }),
    endpoints: (builder) => ({
        // Existing mutation for Link Aggregations Update
        getLinkAggregationsForPortPreview: builder.mutation({
		query: (id) => ({
			url: `${GET_LINK_AGG_API_FOR_PORT_PREVIEW}${id}/`,
			method: 'GET',
		}),
            transformResponse: (response)=>{
                const jsonString = decryptData(response);
			    const res = JSON.parse(jsonString);
                return res?.data
            }
        }),

        getLinkAggregations: builder.mutation({
	query: (id) => ({
		url: `${GET_LINK_KAGGREGATIONS}${id}/`,
		method: 'GET',
	}),
            transformResponse: (response)=>{
                const jsonString = decryptData(response);
			    const res = JSON.parse(jsonString);
                return res?.data
            }
        }),

        // New mutation for Mirror List Update
        getMirrorList: builder.mutation({
	query: (id) => ({
		url: `${GET_MIRROR_LIST}${id}/`,
		method: 'GET',
	}),
            transformResponse: (response)=>{
                const jsonString = decryptData(response);
			    const res = JSON.parse(jsonString);
                return res?.data
            }
        }),
    }),
});

export const {
    useGetLinkAggregationsForPortPreviewMutation,
    useGetLinkAggregationsMutation,
    useGetMirrorListMutation,
} = switchQueryApiSlice;